export default __webpack_public_path__ + "static/media/frame2865.7dda5bfc.jpg";